import { Component, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { RxForLabFacade } from '../../rx-for-lab.facade';
import { DentureDetailsUtils } from '@modules/denture-details/utils/denture-details-utils';
import { ProcedureLoadRxService } from '@modules/order/services/procedure-load-rx.service';
import { BaseDestroyableDirective } from '@shared/base-classes/base-destroyable';
import { RxAttachmentsFacade } from '@shared/rx-attachments/rx-attachments.facade';
import { WINDOW } from '@shared/tokens';
import { BiSessionInfo } from '@itero/rx-attachments/lib/models/analytics/BiSessionInfo';
import { Maybe } from '@/types/globals';

@Component({
	selector: 'rx-for-lab-v1',
	templateUrl: './rx-for-lab-v1.component.html',
	styleUrls: ['./rx-for-lab-v1.component.scss'],
	providers: [RxForLabFacade, RxAttachmentsFacade]
})
export class RxForLabV1Component extends BaseDestroyableDirective implements OnInit {
	isRxloadedAndReady$: Observable<boolean> = this.facade.isRxloadedAndReady$;
	isTeethDiagramAreaVisible$: Observable<boolean> = this.facade.isTeethDiagramAreaVisible$;
	procedureId$: Observable<Maybe<number>> = this.facade.procedureId$;
	rx$ = this.facade.rx$;
	isAttachmentsSectionVisible$: Observable<boolean> = this.rxAttachmentsFacade.isAttachmentsSectionVisible$;
	attachmentsRxId$: Observable<Maybe<string>> = this.facade.attachmentsRxId$;
	companyId$: Observable<Maybe<number>> = this.facade.companyId$;
	isAttachmentsReadOnly$ = this.rxAttachmentsFacade.isAttachmentsReadOnly$;
	biSessionInfo$: Observable<BiSessionInfo> = this.facade.biSessionInfo$;
	contactId$ = this.facade.contactId$;
	userRole$: Observable<any> = this.facade.userRole$;
	timberUrl$: Observable<Maybe<string>> = this.facade.appSettings$.pipe(
		map(({ logging }) => {
			return logging.url;
		}),
		takeUntil(this.componentAlive$)
	);

	isApplianceSectionVisibleForLabs$: Observable<boolean> = this.facade.isApplianceSectionVisibleForLabs$;

	constructor(
		private facade: RxForLabFacade,
		private procedureLoadRxService: ProcedureLoadRxService,
		private rxAttachmentsFacade: RxAttachmentsFacade,
		@Inject(WINDOW) private window: Window
	) {
		super();
	}

	isDentureDetailsVisible(procedureId: number): boolean {
		return DentureDetailsUtils.isDentureDetailsEnabled(procedureId);
	}

	ngOnInit(): void {
		// fill order store
		this.procedureLoadRxService.loadProcedureFlowOrder().pipe(takeUntil(this.componentAlive$)).subscribe();
	}

	onAttachmentsListUpdated(): void {
		const shouldScrollToAttachments = this.window.location.href.includes('#attachments-section');

		if (shouldScrollToAttachments) {
			document.getElementById('attachments-section')?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		}
	}
}
